export const MAX_LICENSE_NAME_LENGTH = 100;
